import { PreviewItem } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { FilteredPreviewItem } from "./filtered-preview-item";
import { PreviewItemFilterOption } from "./preview-item-filter-option";

/**
 * A collection of one or more {@link PreviewItemFilterOption}s,
 * When provided a set of filter rules, can be used to determine if a specific {@link PreviewItem} should be visible.
 */
export abstract class PreviewItemFilters {
    public isReady = false;
    
    public constructor(protected events: EventBroker) {

    }

    /**
     * Retrieves all filter/sorting options available.
     */
    public abstract getFilterOptions(): PreviewItemFilterOption[];

    /**
     * Calls {@link PreviewItemFilterOption.prepare} and {@link PreviewItemFilterOption.track} on all child options.
     * @param previewItems 
     */
    public abstract prepare(previewItems: FilteredPreviewItem[]): void;

    /**
     * Returns true if the item is visible according to all child filters.
     * @param item
     */
    public abstract isVisible(item: FilteredPreviewItem): boolean;

    /**
     * Called after {@link isVisible}.
     */
    public abstract postVisibleCheck(): void;

    /**
     * Sorts the provided items using any child sorting options.
     * @param previewItems
     */
    public abstract sort(previewItems: FilteredPreviewItem[]): void;

    /**
     * Used to indicate if we are viewing a collection.
     */
    public abstract setUserInfo(isCollection: boolean, isAuthed: boolean): void;
}